import React, { useEffect, useState } from 'react';
import Wrapper from '../../components/Wrapper/Wrapper';
import { makeStyles } from '@material-ui/core/styles';

import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import * as logger from "../../../logger";
import {
    getSubscriptionPlans,
    paySubscriptionAction,
    getSubscriptionStatus,
    getPlansAfterCouponApply,
    getPaymentLink
} from "../../../store/actions/paymentsActionCreator";
import useCardStyles from '../css/card'
import Grid from '@material-ui/core/Grid';
import { Card, CardContent, Paper, Typography, Button, CardActions } from '@material-ui/core';
import PremiumPage from "../../components/Card/PremiumPage";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import CheckIcon from '@material-ui/icons/Check';
import { numberFormat, numberFormatPaisa, calculateDiscount } from '../../../utils/utils';
import { trackDwebEvent } from '../../analytics';
import TextField from '@material-ui/core/TextField';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    upgrade: {
        fontSize: 48,
        fontWeight: 600,
        color: '#0b1323',
        marginBottom: 26
    },
    premium: {
        color: '#0033cc'
    },
    priceInfo: {
        fontSize: 24,
        color: "#6b778c",
        marginBottom: 54
    },
    deskApp: {
        color: "#0b1323",
        fontWeight: 600
    },
    enjoy: {
        fontSize: 18,
        color: '#6b778c',
        textAlign: 'center',
        fontWeight: 600,
        marginBottom: 16
    },
    benefitsList: {
        padding: 24,
        paddingBottom: 16
    },
    check: {
        color: '#00875a'
    },
    listText: {
        color: '#0b1323',
        fontWeight: 600
    },
    listItem: {
        padding: 16
    },
    formRoot: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        width: '30ch',
        '& .MuiOutlinedInput-input': {
            padding: '13px 14px',
            backgroundColor: '#fff'
        }
    },
    apply: {
        backgroundColor: '#0033cc',
        marginLeft: 8,
        padding: "10px 16px",
        textTransform: "capitalize"
    },
    applied: {
        backgroundColor: '#00875a',
        marginLeft: 8,
        padding: "10px 16px",
        textTransform: "capitalize"
    },
    formDiv: {
        paddingBottom: 24,
        marginBottom: 24,
        borderBottom: '1px solid #6b778c'
    },
    offer: {
        marginBottom: 16,
        fontSize: 20,
        color: '#0b1323'
    },
    limitedOffer: {
        marginBottom: 24,
        fontSize: 20,
        fontWeight: 600,
        color: '#de1c22',
        textDecoration: 'line-through',
        textDecorationThickness: '3px'
    },
    priceDiv: {
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: 16,
        alignItems: 'center'
    },
    originalPrice: {
        fontSize: 40,
        color: '#0b1323',
        margin: 0
    },
    perYear: {
        fontSize: 20,
        color: '#6b778c',
        marginLeft: 8,
        marginBottom: 0,
    },
    discountPer: {
        fontSize: 20,
        color: '#0b1323',
        fontWeight: 600,
        marginLeft: 8,
        marginBottom: 0,
    },
    finalPrice: {
        color: '#00875a',
        fontSize: 40,
        fontWeight: 600,
        marginBottom: 0,
    },
    makePayment: {
        backgroundColor: '#0033cc',
        width: '38ch',
        padding: 16,
        textAlign: 'center',
        textTransform: 'capitalize',
        borderRadius: 8,
        "&:hover": {
            backgroundColor: '#0033cc'
        }
    },
    retryPayment: {
        backgroundColor: 'red',
        width: '38ch',
        padding: 16,
        textAlign: 'center',
        textTransform: 'capitalize',
        borderRadius: 8,
        fontWeight: 300,
        "&:hover": {
            backgroundColor: 'red'
        }
    },
    actualPrice: {
        fontSize: 20,
        color: '#6b778c'
    },
    limitedPrice: {
        fontSize: 22,
        color: '#0033cc'
    },
    limitedPriceValue: {
        fontSize: 22,
        color: '#0b1323',
        fontWeight: 600,
        textDecoration: 'line-through',
        textDecorationThickness: '2px'
    },
    actualPriceValue: {
        fontSize: 20,
        color: '#0b1323',
        textDecoration: 'line-through',
        textDecorationThickness: '2px'
    },
    couponAppliedList: {
        width: '38ch',
        borderBottom: '1px dotted #7e8a9d',
        marginBottom: 8
    },
    couponListItem: {
        paddingLeft: 0,
        paddingRight: 0
    },
    lastPayment: {
        fontWeight: 300,
        fontSize: 16,
        marginBottom: 16
    }
}));
const Payments = ({ payments, history,
    dispatchGetSubscriptionStatusAction,
    dispatchPayCouponSubscriptionAction,
    dispatchGetSubscriptionPaymentLinkAction,
    dispatchGetSubscriptionPlanAction, dispatchPayForSubscriptionAction, user }) => {
    const classes = useCardStyles();
    const pageClasses = useStyles();
    const [subscriptionPlans, setSubscriptionPlans] = useState(null);
    const [subscriptionStatus, setSubscriptionStatus] = useState(null);
    const [couponApplied, setCouponApplied] = useState(false);
    const [couponInputError, setCouponInputError] = useState(false);
    const [couponInputHelperText, setCouponInputHelperText] = useState(null);
    const [coupon, setCoupon] = useState(null);
    const [price, setPrice] = useState(0);
    const [priceCoupon, setPriceCoupon] = useState(0);
    const [discountValue, setDiscountValue] = useState(0);
    const [discountType, setDiscountType] = useState(null);
    const [reRender, setRender] = useState(false);
    const benefitsList = [
        "Download all the Reports (PDF)",
        "Fully integrated with Mobile App",
        "Create unlimited Trips, Parties, Trucks, and more",
        "Supported for upto 10 users"
    ]
    let premEnabled = user && user.configs && user.configs.subscription && user.configs.subscription.enabled && user.configs.subscription.enabled == 1 ? true : false;
    if (!premEnabled) {
        window.location.href = "/404"
    }
    useEffect(() => {
        dispatchGetSubscriptionStatusAction(
            (data) => {
                logger.log("Payments", "Get user subscription status Success");
            },
            () => {
                logger.log("Payments", "Get user subscription status Failed");
            })
    }, []);

    useEffect(() => {

        if (payments.subscriptionStatus && payments.subscriptionPlans && payments.subscriptionPlans.length > 0) {
            trackDwebEvent('Dweb Subscription Page', {
                free_trial_start_date: payments && payments.subscriptionStatus && payments.subscriptionStatus.subscriptionStartDateEpoch ? payments.subscriptionStatus.subscriptionStartDateEpoch : "",
                days_to_free_trial_expiry: payments && payments.subscriptionStatus && payments.subscriptionStatus.numberOfDays ? payments.subscriptionStatus.numberOfDays : "",
                subscription_amount: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].originalPrice ? payments.subscriptionPlans[0].originalPrice : "",
                amount_to_be_paid: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].price ? payments.subscriptionPlans[0].price : ""
            });
        }

    }, [payments]);

    const goOrderView = (orderId) => {
        if (orderId) {
            history.push({
                pathname: `/payments/order_status/${orderId}`,
                state: {
                    orderId: orderId,
                    pageTitle: 'Premium',
                }
            });
        }
    }
    const goToTryAgainPayment = (data) => {
        if (payments && payments.subscriptionStatus && payments.subscriptionStatus.orderId) {
            dispatchGetSubscriptionPaymentLinkAction(
                payments.subscriptionStatus.orderId,
                (data) => {
                    if (data && data.status && data.status.code == 200 && data.response && data.response.paymentLink) {
                        window.location.href = data.response.paymentLink;
                    }
                },
                () => { },
            )
        }
    }
    /*if (payments && payments.subscriptionStatus 
        && payments.subscriptionStatus.status 
        && payments.subscriptionStatus.subscriptionType
        && payments.subscriptionStatus.orderId
        && payments.subscriptionStatus.status=="PROCESSING"
        && payments.subscriptionStatus.subscriptionType =="PAID"){
        goOrderView(payments.subscriptionStatus.orderId);
    }*/

    useEffect(() => {
        if (!subscriptionPlans && payments && payments.subscriptionStatus
            && payments.subscriptionStatus.status &&
            payments.subscriptionStatus.subscriptionType
            && (
                (payments.subscriptionStatus.status == "EXPIRED" && payments.subscriptionStatus.subscriptionType === "FREE_TRIAL") ||
                (payments.subscriptionStatus.status == "EXPIRED" && payments.subscriptionStatus.subscriptionType === "PAID") ||
                (payments.subscriptionStatus.status == "ACTIVE" && payments.subscriptionStatus.subscriptionType === "FREE_TRIAL") ||
                (payments.subscriptionStatus.status == "PROCESSING" && payments.subscriptionStatus.subscriptionType === "PAID"))) {
            dispatchGetSubscriptionPlanAction(
                (data) => {
                    logger.log("Payments", "Get user subscription plan success");
                    if (data.status && data.status.code == 200) {
                        let plan = data && data.response && data.response[0] ? data.response[0] : null;
                        setSubscriptionPlans(plan);
                        if (plan && plan.price) {
                            setPrice(plan.price);
                        }
                    }
                },
                () => {
                    logger.log("Payments", "Get user subscription plan failed");
                }
            )
        }
    }, [payments]);

    const handleCouponApply = (e) => {
        var paymentOptionData = {
            subscriptionPlan: subscriptionPlans.subscriptionPlan,
            couponCode: coupon
        }
        trackDwebEvent("Dweb Subscription Page Coupon Attempted", {
            free_trial_start_date: payments && payments.subscriptionStatus && payments.subscriptionStatus.subscriptionStartDateEpoch ? payments.subscriptionStatus.subscriptionStartDateEpoch : "",
            days_to_free_trial_expiry: payments && payments.subscriptionStatus && payments.subscriptionStatus.numberOfDays ? payments.subscriptionStatus.numberOfDays : "",
            subscription_amount: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].originalPrice ? payments.subscriptionPlans[0].originalPrice : "",
            amount_to_be_paid: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].price ? payments.subscriptionPlans[0].price : "",
            coupon_code: coupon ? coupon : ""
        });
        dispatchPayCouponSubscriptionAction(
            paymentOptionData,
            (data) => {
                if (data && data.status && data.status.code == 200 && data.response && data.response.amount && data.response.isCouponApplied && data.response.isValidCoupon) {
                    trackDwebEvent("Dweb Subscription Page Coupon Applied", {
                        free_trial_start_date: payments && payments.subscriptionStatus && payments.subscriptionStatus.subscriptionStartDateEpoch ? payments.subscriptionStatus.subscriptionStartDateEpoch : "",
                        days_to_free_trial_expiry: payments && payments.subscriptionStatus && payments.subscriptionStatus.numberOfDays ? payments.subscriptionStatus.numberOfDays : "",
                        subscription_amount: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].originalPrice ? payments.subscriptionPlans[0].originalPrice : "",
                        amount_to_be_paid: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].price ? payments.subscriptionPlans[0].price : "",
                        coupon_code: coupon ? coupon : ""
                    });
                    setCouponApplied(true);
                    setPriceCoupon(Number(data.response.amount));
                    setDiscountValue(data.response.discountValue);
                    setDiscountType(data.response.discountType)
                } else {
                    trackDwebEvent("Dweb Subscription Page Coupon Failed", {
                        free_trial_start_date: payments && payments.subscriptionStatus && payments.subscriptionStatus.subscriptionStartDateEpoch ? payments.subscriptionStatus.subscriptionStartDateEpoch : "",
                        days_to_free_trial_expiry: payments && payments.subscriptionStatus && payments.subscriptionStatus.numberOfDays ? payments.subscriptionStatus.numberOfDays : "",
                        subscription_amount: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].originalPrice ? payments.subscriptionPlans[0].originalPrice : "",
                        amount_to_be_paid: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].price ? payments.subscriptionPlans[0].price : "",
                        coupon_code: coupon ? coupon : "",
                        error_reason: data && data.status && data.status.message ? data.status.message : "",
                    });
                    setCouponApplied(false);
                    setCouponInputError(true);
                    setCouponInputHelperText("Invalid Coupon");
                }
            },
            (data) => {
                trackDwebEvent("Dweb Subscription Page Coupon Failed", {
                    free_trial_start_date: payments && payments.subscriptionStatus && payments.subscriptionStatus.subscriptionStartDateEpoch ? payments.subscriptionStatus.subscriptionStartDateEpoch : "",
                    days_to_free_trial_expiry: payments && payments.subscriptionStatus && payments.subscriptionStatus.numberOfDays ? payments.subscriptionStatus.numberOfDays : "",
                    subscription_amount: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].originalPrice ? payments.subscriptionPlans[0].originalPrice : "",
                    amount_to_be_paid: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].price ? payments.subscriptionPlans[0].price : "",
                    coupon_code: coupon ? coupon : "",
                    error_reason: data && data.status && data.status.message ? data.status.message : "",
                });
            },
        )
    }
    const makePayment = (paymentOption) => {
        var paymentOptionData = {
            subscriptionPlan: paymentOption.subscriptionPlan,
            amount: couponApplied ? Number(priceCoupon) : parseInt(paymentOption.price)
        }
        if (couponApplied) {
            paymentOptionData.couponCode = coupon;
        }
        trackDwebEvent("Dweb Subscription Page Payment Initiated", {
            free_trial_start_date: payments && payments.subscriptionStatus && payments.subscriptionStatus.subscriptionStartDateEpoch ? payments.subscriptionStatus.subscriptionStartDateEpoch : "",
            days_to_free_trial_expiry: payments && payments.subscriptionStatus && payments.subscriptionStatus.numberOfDays ? payments.subscriptionStatus.numberOfDays : "",
            subscription_amount: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].originalPrice ? payments.subscriptionPlans[0].originalPrice : "",
            amount_to_be_paid: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].price ? payments.subscriptionPlans[0].price : "",
            coupon_code: coupon ? coupon : "",
        });
        dispatchPayForSubscriptionAction(
            paymentOptionData,
            (data) => {
                if (data && data.status && data.status.code == 200 && data.response && data.response.paymentLink) {
                    window.location.href = data.response.paymentLink;
                    logger.log("Payments", "Subscription payment Success");
                    trackDwebEvent("Dweb Subscription Page Payment Successfull", {
                        free_trial_start_date: payments && payments.subscriptionStatus && payments.subscriptionStatus.subscriptionStartDateEpoch ? payments.subscriptionStatus.subscriptionStartDateEpoch : "",
                        days_to_free_trial_expiry: payments && payments.subscriptionStatus && payments.subscriptionStatus.numberOfDays ? payments.subscriptionStatus.numberOfDays : "",
                        subscription_amount: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].originalPrice ? payments.subscriptionPlans[0].originalPrice : "",
                        amount_to_be_paid: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].price ? payments.subscriptionPlans[0].price : "",
                        coupon_code: coupon ? coupon : "",
                        order_id: data && data.response && data.response.orderId ? data.response.orderId : "",
                    });
                } else {
                    trackDwebEvent("Dweb Subscription Page Payment Failed", {
                        free_trial_start_date: payments && payments.subscriptionStatus && payments.subscriptionStatus.subscriptionStartDateEpoch ? payments.subscriptionStatus.subscriptionStartDateEpoch : "",
                        days_to_free_trial_expiry: payments && payments.subscriptionStatus && payments.subscriptionStatus.numberOfDays ? payments.subscriptionStatus.numberOfDays : "",
                        subscription_amount: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].originalPrice ? payments.subscriptionPlans[0].originalPrice : "",
                        amount_to_be_paid: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].price ? payments.subscriptionPlans[0].price : "",
                        coupon_code: coupon ? coupon : "",
                        error_reason: data && data.status && data.status.message ? data.status.message : "",
                        order_id: data && data.response && data.response.orderId ? data.response.orderId : "",
                    });
                }
            },
            (data) => {
                trackDwebEvent("Dweb Subscription Page Payment Failed", {
                    free_trial_start_date: payments && payments.subscriptionStatus && payments.subscriptionStatus.subscriptionStartDateEpoch ? payments.subscriptionStatus.subscriptionStartDateEpoch : "",
                    days_to_free_trial_expiry: payments && payments.subscriptionStatus && payments.subscriptionStatus.numberOfDays ? payments.subscriptionStatus.numberOfDays : "",
                    subscription_amount: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].originalPrice ? payments.subscriptionPlans[0].originalPrice : "",
                    amount_to_be_paid: payments && payments.subscriptionPlans && payments.subscriptionPlans[0] && payments.subscriptionPlans[0].price ? payments.subscriptionPlans[0].price : "",
                    coupon_code: coupon ? coupon : "",
                    error_reason: data && data.status && data.status.message ? data.status.message : "",
                    order_id: data && data.response && data.response.orderId ? data.response.orderId : "",
                });
                logger.log("Payments", "Subscription payment failure");
            },
        )

    };

    return (
        <Wrapper>
            {payments && payments.subscriptionStatus
                && payments.subscriptionStatus.status &&
                payments.subscriptionStatus.subscriptionType
                && (
                    (payments.subscriptionStatus.status == "EXPIRED" && payments.subscriptionStatus.subscriptionType === "FREE_TRIAL") ||
                    (payments.subscriptionStatus.status == "EXPIRED" && payments.subscriptionStatus.subscriptionType === "PAID") ||
                    (payments.subscriptionStatus.status == "ACTIVE" && payments.subscriptionStatus.subscriptionType === "FREE_TRIAL") ||
                    (payments.subscriptionStatus.status == "PROCESSING" && payments.subscriptionStatus.subscriptionType === "PAID")) && <>
                    <Grid spacing={3} container>
                        <Grid item xs={12} >
                            <h6 className={pageClasses.upgrade} >Upgrade to <span className={pageClasses.premium}>Premium</span></h6>
                            <h6 className={pageClasses.priceInfo}>Upgrade to premium to access the <span className={pageClasses.deskApp}>Desktop App</span> at {numberFormatPaisa(Number(price))} per year</h6>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <Paper className={pageClasses.benefitsList}>
                                <div className={pageClasses.enjoy}>Enjoy the following benefits</div>
                                <List>
                                    {benefitsList && benefitsList.map((text) => {
                                        return (<ListItem className={pageClasses.listItem}>
                                            <ListItemIcon>
                                                <CheckIcon className={pageClasses.check} />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={text}
                                                primaryTypographyProps={{
                                                    className: pageClasses.listText,
                                                }}
                                            />
                                        </ListItem>)
                                    })}
                                </List>
                            </Paper>
                        </Grid>
                        {payments.subscriptionStatus.orderId && <Grid item xs={12} sm={6}>
                            <Typography className={pageClasses.lastPayment}>
                                Your last payment failed, please retry payment again
                    </Typography>
                            <div>
                                <Button variant="contained" onClick={(e) => { goToTryAgainPayment() }} className={pageClasses.retryPayment} color="primary">
                                    Retry the payment
                        </Button>
                            </div>
                        </Grid>}
                        {subscriptionPlans && !payments.subscriptionStatus.orderId && <Grid item xs={12} sm={6}>
                            <div className={pageClasses.formRoot}>
                                <div className={pageClasses.formDiv}>
                                    <TextField
                                        variant="outlined"
                                        labelWidth={0}
                                        value={coupon}
                                        onChange={(e) => {
                                            setCouponInputError(false);
                                            setCouponInputHelperText(null);
                                            setCouponApplied(false);
                                            setCoupon(e.target.value)
                                        }
                                        }
                                        label=""
                                        error={couponInputError}
                                        helperText={couponInputHelperText}
                                        placeholder="Enter Coupon"
                                        id="standard-start-adornment"
                                        className={clsx(pageClasses.textField)}
                                    />
                                    <Button variant="contained" onClick={handleCouponApply} className={couponApplied ? pageClasses.applied : pageClasses.apply} color="primary">
                                        {couponApplied ? <span><CheckIcon />Applied</span> : 'Apply'}
                                    </Button>
                                </div>
                            </div>
                            {subscriptionPlans && !couponApplied && <div>
                                <p className={pageClasses.offer}>{subscriptionPlans.offerName ? subscriptionPlans.offerName : "Limited Period Offer"}</p>
                                <p className={pageClasses.limitedOffer}>{numberFormatPaisa(subscriptionPlans.originalPrice ? Number(subscriptionPlans.originalPrice) : 0)}</p>
                                <div className={pageClasses.priceDiv}>
                                    <p className={pageClasses.originalPrice}>{numberFormatPaisa(subscriptionPlans.price ? Number(subscriptionPlans.price) : 0)}</p>
                                    <p className={pageClasses.perYear}>Per Year</p>
                                </div>
                            </div>}
                            {couponApplied && <div>
                                <div>
                                    <List className={pageClasses.couponAppliedList}>
                                        <ListItem className={pageClasses.couponListItem}>
                                            <ListItemText
                                                primary={"Actual Price"}
                                                primaryTypographyProps={{
                                                    className: pageClasses.actualPrice,
                                                }}
                                            />
                                            <span className={pageClasses.actualPriceValue}>{numberFormatPaisa(subscriptionPlans.originalPrice ? Number(subscriptionPlans.originalPrice) : 0)}</span>
                                        </ListItem>
                                        <ListItem className={pageClasses.couponListItem}>
                                            <ListItemText
                                                primary={"Offer Price"}
                                                primaryTypographyProps={{
                                                    className: pageClasses.limitedPrice,
                                                }}
                                            />
                                            <span className={pageClasses.limitedPriceValue}>{numberFormatPaisa(subscriptionPlans.price ? Number(subscriptionPlans.price) : 0)}</span>
                                        </ListItem>
                                    </List>
                                </div>
                                <div>
                                    <div className={pageClasses.priceDiv}>
                                        <p className={pageClasses.finalPrice}>{numberFormatPaisa(priceCoupon)}</p>
                                        {discountType && discountType == 'PERCENTAGE' && <p className={pageClasses.discountPer}>
                                            {/* {Math.round(calculateDiscount(Number(subscriptionPlans.price),Number(priceCoupon)))}% */}
                                            {numberFormatPaisa(Number(discountValue))}% off
                                </p>}
                                        {discountType && discountType == 'AMOUNT' && <p className={pageClasses.discountPer}>{numberFormatPaisa(Number(discountValue))} off</p>}
                                        <p className={pageClasses.perYear}>Offer Applied</p>
                                    </div>
                                </div>
                            </div>}
                            <div>
                                <Button variant="contained" onClick={(e) => { makePayment(subscriptionPlans) }} className={pageClasses.makePayment} color="primary">
                                    Make Payment
                        </Button>
                            </div>
                        </Grid>}
                    </Grid>
                </>}
            {/* { payments.subscriptionPlans && <Grid container>
            { payments.subscriptionPlans && payments.subscriptionPlans.map((tile) => (<Grid item xs={4}>
                   <Card>
                   <CardContent>
                   <Typography variant="h5" gutterBottom>
                        {tile.displayName}
                    </Typography>
                    <Typography>
                        Offer Price: {tile.offerPrice}
                    </Typography>
                    <Typography>
                        Original Price: {tile.originalPrice}
                    </Typography>
                    </CardContent>
                    <CardActions disableSpacing>
                    <Button
                            variant="contained"
                            color="primary"
                            onClick={() => makePayment(tile)}
                            fullWidth={true}
                        >
                            <span className={classes.font1}>Pay</span>
                        </Button>
                     </CardActions>
                    </Card>
               </Grid>
           ))}
            </Grid> } */}
            {/* {payments.subscriptionStatus && <Card>
                   <CardContent>
                   <Typography variant="h5" gutterBottom>
                        Organisation name {payments.subscriptionStatus.orgName}
                    </Typography>
                    <Typography>
                        Subscription StartDate : {payments.subscriptionStatus.subscriptionStartDateEpoch}
                    </Typography>
                    <Typography>
                        Subscription EndDate : {payments.subscriptionStatus.subscriptionEndDateEpoch}
                    </Typography>
                    <Typography>
                        {payments.subscriptionStatus.subscriptionType}
                    </Typography>
                    </CardContent>
                    </Card>} */}
            {payments && payments.subscriptionStatus
                && payments.subscriptionStatus.status &&
                payments.subscriptionStatus.subscriptionType
                && (payments.subscriptionStatus.status == "ACTIVE")
                && payments.subscriptionStatus.subscriptionType == "PAID" && <PremiumPage status={payments.subscriptionStatus} />}
        </Wrapper>
    );

};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchGetSubscriptionPlanAction: (onSuccess, onFailure) => {
        dispatch(getSubscriptionPlans(onSuccess, onFailure))
    },
    dispatchPayForSubscriptionAction: (data, onSuccess, onFailure) => {
        dispatch(paySubscriptionAction(data, onSuccess, onFailure))
    },
    dispatchPayCouponSubscriptionAction: (data, onSuccess, onFailure) => {
        dispatch(getPlansAfterCouponApply(data, onSuccess, onFailure))
    },
    dispatchGetSubscriptionStatusAction: (onSuccess, onFailure) => {
        dispatch(getSubscriptionStatus(onSuccess, onFailure))
    },
    dispatchGetSubscriptionPaymentLinkAction: (id, onSuccess, onFailure) => {
        dispatch(getPaymentLink(id, onSuccess, onFailure))
    }
});
const PaymentsWithRouter = withRouter(Payments);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentsWithRouter);
